import styled from 'styled-components';
import Image from '@klv/atoms/image';

export const ImageContainer = styled.div`
  overflow: hidden;
  pointer-events: none;
  width: 100%;
`;

export const StyledImage = styled(Image)`
  width: 100%;
  height: auto;
  transition: all .3s ease-in-out;
  display: block;
  transform: scale(1.005);
`;

export const TextContainer = styled.div`
  background-color: rgba(16, 14, 14, 0.2);
  padding: 1.4rem 0 1.9rem 1.7rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  
  svg {
    padding: .1rem;
    transition: all .3s ease-in-out;
  }

  ${({ theme }) => `
  ${theme.screenSize.s576.mediaQuery} {
    padding: 2.4rem 0 3.4rem 2.9rem;
  }
  ${theme.screenSize.s768.mediaQuery} {
    padding: 2.6rem 0 3.6rem 3rem;
  }
`}
`;

export const Text = styled.div`
  font-size: 1.8rem;
  font-family: "Sohne";
  line-height: 1.15;
  line-height: 1.3;
  margin-right: .8rem;

  ${({ theme }) => `
    color: ${theme.colors.white};

    ${theme.screenSize.s576.mediaQuery} {
      font-size: 2rem;
    }
    ${theme.screenSize.s1200.mediaQuery} {
      font-size: 2.4rem;
      line-height: 1.3;
    }
  `}
`;

export const StyledAudienceCard = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 1.5rem;
  overflow: hidden;
  perspective: 1px; 
  background-color: transparent;
  padding: 0;
  border: none;
  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      grid-column: span 6;
    }
  `}

  &:hover, &:focus {
    cursor: pointer;

    ${({ theme }) => `
      ${theme.screenSize.s1024.mediaQuery} {
        ${StyledImage} {
          transform: scale(1.05);
        }
        ${TextContainer}{
          svg {
            transform: translateX(8px);
          }
        }
      }   
    `} 
  }
`;
